import { DraftPlatforms } from '../redux/slices/notifications/types';

export const getPlatformsFromDraftPlatforms = (platforms: DraftPlatforms) => ({
  ios: platforms.includes('ios'),
  android: platforms.includes('android'),
});
